export const INITIAL_GENERATOR = {
    character_amount: null,
    total: null,
    prefix: null,
}

export const INITIAL_STATE = {
    new_code: null,
    target_code: null,
}

export const GET_FIELD_NAME = {
    new_code: 'Kode voucher',
    target_code: 'Kode voucher',
}
